import {
  appendReturnTo,
  fetchWizardRequiredComplete,
  getWizardOnboardingPath,
  isWizardOnboardingPath,
} from '../shared/onboardingTaskNavigation';
import { clearGuestBrowseIntent, safeInternalPath } from './guestBrowseIntent';

export function isRecognizedLoginUserType(userType) {
  return userType === 'brand' || userType === 'influencer' || userType === 'admin';
}

export function getPostLoginPath(userType, returnTo, { wizardComplete = true } = {}) {
  if (userType === 'admin') return '/admin/overview';

  const safeReturn = safeInternalPath(returnTo);
  const onboardingPath = getWizardOnboardingPath(userType);
  if (safeReturn && isWizardOnboardingPath(safeReturn)) return safeReturn;
  if (!wizardComplete && onboardingPath) return appendReturnTo(onboardingPath, safeReturn);
  if (safeReturn) return safeReturn;
  if (userType === 'influencer' || userType === 'brand') return '/dashboard/overview';
  return '/';
}

export async function navigateAfterLogin(navigate, userType, returnTo) {
  let wizardComplete = true;
  if (userType === 'influencer' || userType === 'brand') {
    try {
      wizardComplete = await fetchWizardRequiredComplete(userType);
    } catch {
      wizardComplete = false;
    }
  }
  if (wizardComplete) clearGuestBrowseIntent();
  navigate(getPostLoginPath(userType, returnTo, { wizardComplete }), { replace: true });
}
